exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.reportTbl[data-v-b00b033a]{width:100%;border-collapse:collapse}.reportTbl td[data-v-b00b033a]{border:1px solid #ccc;padding:6px}.reportTbl tr td[data-v-b00b033a]{text-align:left;line-height:15px}.txtRight[data-v-b00b033a]{text-align:right!important}.reportTbl tr.txtCenter td[data-v-b00b033a]{text-align:center}.reportTbl tr.tb-td td[data-v-b00b033a]{font-weight:700;text-align:center;border:none}td.textCenter[data-v-b00b033a]{text-align:center!important}td.textRight[data-v-b00b033a]{text-align:right!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b00b033a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reportGenerate/pdf/procurementReport.vue
// module id = 1612
// module chunks = 3